<template>
  <div class="nps-card">
    <div class="nps-card-title">{{ title }}</div>
    <charts :options="chartOptions"></charts>
    <div class="donut-legend">
      <div v-for="item in items" :key="item.label" class="legend-item">
        <span class="legend-dot" :style="{ background: item.color }"></span>
        <span>{{ legendText(item) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaDonutChartCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return [];
      }
    },
    height: {
      type: Number,
      default: 200
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'pie',
          height: this.height,
          spacing: [0, 0, 0, 0]
        },
        title: {
          text: null
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            innerSize: '65%',
            borderWidth: 0,
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          name: this.title,
          data: this.items.map((item) => ({
            name: item.label,
            y: item.value,
            color: item.color
          }))
        }]
      };
    }
  },
  methods: {
    legendText (item) {
      if (item.legend) {
        return item.legend;
      }

      return `${this.translateLabel(item.label)} - ${Number(item.pct || 0).toFixed(1)}%`;
    },
    translateLabel (value) {
      const labels = {
        Promoters: 'Promotores',
        Neutrals: 'Neutros',
        Detractors: 'Detractores'
      };

      return labels[value] || value;
    }
  }
};
</script>

<style scoped>
.nps-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  padding: 20px 22px;
}

.nps-card-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 14px;
}

.donut-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.legend-item {
  align-items: center;
  color: var(--text-primary, #1A1A2E);
  display: flex;
  font-size: 12px;
  gap: 8px;
}

.legend-dot {
  border-radius: 50%;
  flex-shrink: 0;
  height: 12px;
  width: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/DonutChartCard.vue